import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import Config, { PaginationLimit } from "../../Config";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import moment from "moment";
import { IoMdMore } from "react-icons/io";
import { MdModeEdit, MdRemoveCircleOutline } from "react-icons/md";
import {
  FaCheckCircle,
  FaUtensils,
  FaFileContract,
  FaCode,
  FaBolt,
  FaTools,
  FaExclamationCircle,
} from "react-icons/fa";

const Table = ({
  ApiData,
  userType,
  setAddExtraCharges,
  setSelectedData,
  LinkMutate,
}) => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [previousId, setPreviousId] = useState(null);

  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);

  const ActionBtns = (item) => {
    const openMenu = (id) => {
      setPreviousId(openActionMenu);
      setOpenActionMenu((prevId) => {
        return prevId === id ? null : id;
      });
    };

    const editAddExtraCharges = (item) => {
      setAddExtraCharges(true);
      setSelectedData(item);
      setOpenActionMenu(null);
    };

    const unlinkCharges = async (item) => {
      LinkMutate(item);
      openActionMenu(null);
    };

    return (
      <ActionBtnWrapper>
        {openActionMenu === item.id && (
          <MenuOptions id="menuOptions">
            {userType != Config.userType.MARKETING && (
              <MenuItem
                title="addExtraCharges"
                onClick={() => {
                  editAddExtraCharges(item);
                  setOpenActionMenu(null);
                }}
              >
                {/* onClick={() => edit(item)}> */}
                <MdModeEdit className="text-gray-700" /> Edit
              </MenuItem>
            )}
            <MenuItem
              title="unlinkCharges"
              onClick={() => {
                unlinkCharges(item);
                setOpenActionMenu(null);
              }}
            >
              <MdRemoveCircleOutline className="text-gray-700 " /> Unlink
              Charges
            </MenuItem>
          </MenuOptions>
        )}
        <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
          <IoMdMore className="text-gray-600" size={24} />
        </Btn>
      </ActionBtnWrapper>
    );
  };

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getRepetition = (data) => {
    if (data == 1) {
      return <RepetOnce>Once</RepetOnce>;
    } else return <RepetMonthly>Monthly</RepetMonthly>;
  };

  // const getName = (item) => {
  //   return <span className="text-zinc-900 font-semibold">{item.name} </span>;
  // };
  // const getName = (data) => {
  //   if (data == "Registration") return <Verified>Registration</Verified>;
  //   else if (data == "Food") return <Enrolled>Food</Enrolled>;
  //   else if (data == "Agreement Charge")
  //     return <Agreement>Agreement </Agreement>;
  //   else if (data == "Tech") return <Active>Tech</Active>;
  //   else if (data == "Electricity")
  //     return <Electricity>Electricity</Electricity>;
  //   else if (data == "Maintenance")
  //     return <Maintenance>Maintenance</Maintenance>;
  //   else return <Unverified>{data.split(" ")[0]}</Unverified>;
  // };
  const getName = (data) => {
    switch (data) {
      case "Registration":
        return (
          <p className="bg-teal-100 text-gray-500 border-teal-300 border text-xs py-1  max-w-fit h-7 px-4 flex items-center justify-center rounded-lg">
            <FaCheckCircle className="inline mr-2 text-gray-500 " />
            Registration
          </p>
        );
      case "Food":
        return (
          <p className="bg-lime-100 text-gray-500 border-lime-300 border text-xs py-1  max-w-fit h-7 px-4 flex items-center justify-center rounded-lg">
            <FaUtensils className="inline mr-2 text-gray-500 " />
            Food
          </p>
        );
      case "Agreement Charge":
        return (
          <p className="bg-blue-100 text-gray-500 border-blue-300 border text-xs py-1  max-w-fit h-7 px-4 flex items-center justify-center rounded-lg">
            <FaFileContract className="inline mr-2 text-gray-500 " />
            Agreement
          </p>
        );
      case "Tech":
        return (
          <p className="bg-purple-100 text-gray-500 border-purple-300 border text-xs py-1  max-w-fit h-7 px-4 flex items-center justify-center rounded-lg">
            <FaCode className="inline mr-2 text-gray-500 " />
            Tech
          </p>
        );
      case "Electricity":
        return (
          <p className="bg-yellow-100 text-gray-500 border-yellow-300 border text-xs py-1  max-w-fit h-7 px-4 flex items-center justify-center rounded-lg">
            <FaBolt className="inline mr-2 text-gray-500 " />
            Electricity
          </p>
        );
      case "Maintenance":
        return (
          <p className="bg-gray-100 text-gray-500 border-gray-300 border text-xs py-1  max-w-fit h-7 px-4 flex items-center justify-center rounded-lg">
            <FaTools className="inline mr-2 text-gray-500 " />
            Maintenance
          </p>
        );
      default:
        return (
          <p className="bg-rose-100 text-gray-500 border-rose-300 border text-xs py-1  max-w-fit h-7 px-4 flex items-center justify-center rounded-lg">
            <FaExclamationCircle className="inline mr-2 text-gray-500 " />
            {data.split(" ")[0]}
          </p>
        );
    }
  };

  useEffect(() => {
    if (ApiData) {
      const tempData = ApiData.map((item) => ({
        name: getName(item.name),
        date: (
          <span className="mr-3">
            {moment(item.createdAt).format("DD-MM-YYYY")}
          </span>
        ),
        charges: (
          <span className="font-semibold mr-5">{"₹" + item.amount}</span>
        ),

        // status: getStatus(item.status),
        action: ActionBtns(item),
        repetation: getRepetition(item.repetitionType),
      }));
      setData(tempData);
    }
  }, [ApiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const columns = useMemo(() => {
    if (isMobileView) {
      // Display only "User" column for mobile screens
      return [
        {
          Header: "Amount",
          accessor: "charges",
        },
        {
          Header: "Charges For",
          accessor: "name",
        },
      ];
    }

    // Columns for larger screens
    return [
      // {
      //   Header: " ",
      // },
      {
        Header: "Amount",
        accessor: "charges",
      },
      {
        Header: "Due From",
        accessor: "date",
      },
      {
        Header: "Charges For",
        accessor: "name",
      },
      {
        Header: "Repetition",
        accessor: "repetation",
      },
      //   {
      //     Header: "Created At",
      //     accessor: "date",
      //   },
      //   {
      //     Header: "Status",
      //     accessor: "status",
      //   },
      {
        Header: "Action",
        accessor: "action",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );
  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);
  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(ApiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr {...row.getRowProps()} hasdata={(ApiData?.length > 0).toString()}>
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>City:</strong> {data[rowIndex].city}
                        </li>
                        <li>
                          <strong>Created At:</strong> {data[rowIndex].date}
                        </li>
                        <li className="flex gap-2">
                          <strong>Status:</strong> {data[rowIndex].status}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75 "
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};
// const Btn = tw.button`grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
// const ActionBtnWrapper = tw.div`grid xl:grid-cols-2 md:grid-cols-1 grid-cols-4 w-40 mb-1 gap-y-1 gap-x-1.5 md:w-16 mt-3 md:mt-0`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${(props) => (props.hasdata ==="true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-medium cursor-pointer hover:bg-gray-100`;

const RepetOnce = tw.div`bg-purple-100 text-purple-700 border-purple-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded-full`;
const RepetMonthly = tw.div`bg-blue-100 text-blue-700 border-blue-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded-full`;
export default Table;
